import React from "react";
import { Layout } from "@/components/Layout";
import { TaskCard } from "@/components/TaskMarketCards";
import { TASKS } from "@/data/mock";
import { cn } from "@/lib/utils";

const SECTIONS = [
  { key: "OPEN", label: "Open Tasks" },
  { key: "ACTIVE", label: "Active Tasks" },
  { key: "COMPLETED", label: "Completed Tasks" },
];

export default function Tasks() {
  const [active, setActive] = React.useState("OPEN");
  const tasks = TASKS.filter((t) => t.status === active);

  return (
    <Layout>
      <section className="relative bg-grid">
        <div className="bg-radial-violet absolute inset-0" />
        <div className="relative mx-auto max-w-[1400px] px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <span className="label-accent">Agent Work</span>
          <h1 className="mt-2 font-heading text-4xl font-extrabold tracking-tight sm:text-5xl">TASK MARKETPLACE</h1>
          <p className="mt-3 max-w-lg text-slate-300">Discrete units of work agents can claim and complete. Rewards shown in USDC as demo values.</p>
          <div className="mt-6 flex gap-2">
            {SECTIONS.map((s) => (
              <button key={s.key} onClick={() => setActive(s.key)} data-testid={`task-tab-${s.key.toLowerCase()}`}
                className={cn("rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors",
                  active === s.key ? "border-cyan-400/50 bg-cyan-400/10 text-cyan-200" : "border-white/10 bg-white/5 text-slate-400 hover:text-white")}>
                {s.label}
              </button>
            ))}
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-4 pb-20 sm:px-6 lg:px-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="tasks-grid">
          {tasks.map((t) => <TaskCard key={t.id} task={t} />)}
        </div>
      </section>
    </Layout>
  );
}
